import * as uiHelpers from "../KycUIHelpers";

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import SVG from "react-inlinesvg";
import {
  getHandlerTableChange,
  getSelectRow,
  sortCaret,
  toAbsoluteUrl
} from "../../../../_metronic/_helpers";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { updateKycStatus } from "../_redux/QTasksCrud";
import NoRecord from "../../../../_metronic/_partials/widgets/NoRecord";
import NotAuthorized from "../../../../_metronic/_partials/widgets/NotAuthorized";
import { BootstrapTable, Pagination, PaginationProvider, paginationFactory } from "../../../../_metronic/_partials/controls";
import { fetchQTasks } from "../_redux/QTasksAction";
import moment from "moment";
import { useIntl } from "react-intl";
import { useQTasksUIContext } from "../KycUIContext";
import ContactDealTaskModal from "../../../../_metronic/_partials/widgets/alert/ContactDealTaskModal";
import SnackBarTool from "../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import { NameCheckBadge } from "../../../../_metronic/_partials/widgets/order/NameCheck";
import EditIcon from '@mui/icons-material/Edit';

// added imports
import { Modal, Button, Form } from "react-bootstrap";


/**
 * The Status cell of an Onboarding list row: the ID/contract status pill,
 * the Stripe check badge, and the ID name check badge when one is open.
 *
 * @param {Object} row A KYC contract row from the list API
 * @returns {JSX.Element}
 */
const renderSubscriptionWithKyc = (row) => {
  const status = row?.user?.kyc_status || row?.kyc_status || "";
  const stripeCheck = row?.stripe_check_status || row?.stripe_check || null;

const statusMap = {
  // 📌 KYC STAGES
  pending_kyc: {
    label: "Pending ID Verification",
    color: "#FF9800",     // customer pending
    bg: "#FFF3E0",
  },
  pending_manual_kyc: {
    label: "Pending Manual Id Verification",
    color: "#FBC02D",     // staff manual work
    bg: "#FFF8E1",
  },
  send_pending_kyc: {
    label: "ID Verification Email Sent",
    color: "#FF9800",
    bg: "#FFF3E0",
  },

  // 📌 CONTRACT STAGES
  pending_contract_sign: {
    label: "Pending Contract Sign",
    color: "#FF9800",
    bg: "#FFF3E0",
  },
  pending_manual_contract_sign: {
    label: "Pending Manual Contract Sign",
    color: "#FBC02D",
    bg: "#FFF8E1",
  },

  manual_contract_sign_complete: {
    label: "Contract Signed (Manual)",
    color: "#2E7D32",     // soft success (positive event)
    bg: "#E8F5E9",
  },

  // ⭐ Pending Access = Orange text + greenish bg (positive pending)
  pending_access: {
    label: "Pending Access",
    color: "#FF9800",     // PENDING
    bg: "#E8F5E9",        // but success category
  },

  manual_access_complete: {
    label: "Manual Access Complete",
    color: "#2E7D32",
    bg: "#E8F5E9",
  },

  complete: {
    label: "Complete",
    color: "#1B5E20",     // final success
    bg: "#D1E7DD",
  },

  void_1_hour_before_kyc: {
    label: "CANCEL (1 Hour Before ID Verification)",
    color: "#D32F2F",
    bg: "#FFEBEE",
  },

   void_1_hour_before_sign: {
    label: "CANCEL (1 Hour Before Contract Sign)",
    color: "#D32F2F",
    bg: "#FFEBEE",
  },

  // Existing General
  verified: {
    label: "Verified",
    color: "#2E7D32",
    bg: "#E8F5E9",
  },

  rejected: {
    label: "Rejected",
    color: "#D32F2F",
    bg: "#FFEBEE",
  },

  send_pending_contract_sign: {
    label: "Contract Email Sent",
    color: "#FF9800",
    bg: "#FFF3E0",
  },
};



  const stripeStatusMap = {
    verified: { color: "#198754", bg: "#E8F5E9" },
    success: { color: "#198754", bg: "#E8F5E9" },
    pending: { color: "#FF8C00", bg: "#FFF4E5" },
    failed: { color: "#DC3545", bg: "#FDECEA" },
    error: { color: "#DC3545", bg: "#FDECEA" },
    failed_verification: { color: "#DC3545", bg: "#FDECEA" },
  };

  const info =
    statusMap[status] || {
      label: (status || "-").replace(/_/g, " "),
      color: "#6C757D",
      bg: "#F8F9FA",
    };

  const stripeInfo = stripeCheck && stripeStatusMap[String(stripeCheck).toLowerCase()]
      ? stripeStatusMap[String(stripeCheck).toLowerCase()]
      : { color: "#6C757D", bg: "#F8F9FA" };
    
      
        // ⬇️ <-- PASTE THIS HERE
      const isVoidStatus = status === "void_1_hour_before_kyc" || status === "void_1_hour_before_sign";

      // If order cancel but NOT void status → override with Cancelled
      if (!isVoidStatus && row?.order?.is_cancel == 1) {
        return (
          <div className="d-flex flex-column gap-1">
            <div
              className="d-inline-flex align-items-center px-3 py-1 rounded-pill"
              style={{
                color: "#D32F2F",
                background: "#FFEBEE",
                border: "1px solid #D32F2F",
                fontSize: 13,
                fontWeight: 600,
                minWidth: 150,
              }}
            >
              <span>Order Cancelled</span>
            </div>
          </div>
        );
      }

      
  return (
    <div className="d-flex flex-column gap-1">
      <div
        className="d-inline-flex align-items-center px-3 py-1 rounded-pill"
        style={{
          color: info.color,
          background: info.bg,
          border: `1px solid ${info.color}`,
          fontSize: 13,
          fontWeight: 600,
          gap: 6,
          minWidth: 150,
        }}
      >
      <span>{info.label}</span>
        {stripeCheck && (
          <small
            className="ms-2 px-2 py-0 rounded-pill"
            style={{
              color: stripeInfo.color,
              background: stripeInfo.bg,
              border: `1px solid ${stripeInfo.color}`,
              fontSize: 10, // smaller than main text
              lineHeight: "14px",
            }}
          >
            {(row?.order?.is_cancel) ? "Order cancelled" : String(stripeCheck).toUpperCase()}
          </small>
        )}
      </div>
      <NameCheckBadge status={row?.name_check_status} fontSize={11} />
    </div>
  );
};



const KycTable = ({ show, setShow, permission }) => {
  const intl = useIntl();
  const TasksUIContext = useQTasksUIContext();
  const [dialog, setDialog] = useState({ type: "", open: false, id: "" });
  // new local state for small status modal fallback
  const [statusDialog, setStatusDialog] = useState({
    open: false,
    id: null,
    status: "",
    row: null,
  });
  // surfaces API failures from the status actions (see handleUpdateStatus).
  // `id` increments once per notification and is used as the snackbar's key:
  // SnackBarTool latches its own `open` state on mount, so without a remount a
  // second failure would stay hidden after the first one auto-hides.
  const [snack, setSnack] = useState({ call: false, type: "", message: "", id: 0 });

  const TasksUIProps = useMemo(() => {
    return {
      ids: TasksUIContext?.ids,
      setIds: TasksUIContext?.setIds,
      queryParams: TasksUIContext?.queryParams,
      setQueryParams: TasksUIContext?.setQueryParams,
      openEditContactPage: TasksUIContext?.openEditContactPage,
      openDeleteContactDialog: TasksUIContext?.openDeleteContactDialog,
      // expose update hook if provider supplied one
      openUpdateTasksStatusDialog:
        TasksUIContext?.openUpdateTasksStatusDialog,
    };
  }, [TasksUIContext]);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { currentState } = useSelector(
    (state) => ({ currentState: state.kyc.list }),
    shallowEqual
  );

  const { totalCount, entities, loading } = currentState;
  useEffect(() => {
    // clear selections list
    // server call by queryParams
    TasksUIProps.setIds([]);

    dispatch(fetchQTasks(TasksUIProps.queryParams));
    // dispatch(fetchAgent());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TasksUIProps.queryParams, dispatch]);

  useEffect(() => {
    TasksUIProps.setQueryParams(uiHelpers.initialFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // ensure table has stable unique key per row to avoid row-content mismatch
  const tableData = (entities || []).map((r) => {
    const uid =
      r?.id ??
      r?.order_id ??
      r?.order?.id ??
      r?.order?.booking_reference ??
      `${r?.order?.user_id || "u"}-${r?.id || Math.random()}`;
    return { ...r, __tableId: uid };
  });

  const columns = [

    {
      dataField: "",
      text: "Order ID",
      sort: true,
      sortCaret: sortCaret,
      formatter: (e, data) => {
        return <span>{data?.order.booking_reference}</span>;
      },
    },
    {
      dataField: "",
      text: "Name",
      sort: false,
      sortCaret: sortCaret,
      formatter: (e, data) => {
        return (
          <span>
            {data?.order.user?.first_name}{" "}
            {data?.order.user?.last_name}
          </span>
        );
      },
    },
    {
      dataField: "",
      text: "email",
      sort: false,
      sortCaret: sortCaret,
      formatter: (e, data) => {
        return <span>{data?.order.user?.email}</span>;
      },
    },
    {
      dataField: "",
      text: "Phone",
      sort: false,
      sortCaret: sortCaret,
      formatter: (e, data) => {
        return <span>{data?.order.user?.phone}</span>;
      },
    },
    

    // new column: subscription id + kyc status below it
    {
      dataField: "",
      text: "Status",
      sort: false,
      sortCaret: sortCaret,
      formatter: (cell, row) => renderSubscriptionWithKyc(row),
      headerStyle: () => ({ width: "240px" }),
    },
    {
      dataField: "",
      text: "Status At",
      sort: false,
      sortCaret: sortCaret,
      formatter: (cell, row) => (
        <span>
          {row?.kyc_requested_at
            ? moment(row?.kyc_requested_at).format("DD-MM-YYYY")
            : "-"}
        </span>
      ),
      headerStyle: () => ({ width: "98px" }),
    },
    {
      dataField: "",
      text: "Actions",
      formatter: (cell, row) => (
        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="btn btn-icon btn-sm"
            // stop propagation early (mouseDown) and on click
            // onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              if (TasksUIProps.openUpdateTasksStatusDialog) {
                TasksUIProps.openUpdateTasksStatusDialog(row);
              } else {
                setStatusDialog({
                  open: true,
                  id: row.id,
                  status: row?.user?.kyc_status || "",
                  row,
                });
              }
            }}
            title="Update Status"
          >
            <EditIcon/>
          </button>
        </div>
      ),
      headerStyle: () => ({ width: "100px" }),
    },
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: TasksUIProps.queryParams?.pageSize,
    page: TasksUIProps.queryParams?.pageNumber,
  };
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      navigate(`/order-details/${row?.order_id}`);
    },
  };
  /**
   * Local handler for the fallback modal — defers to the provider callback when
   * one is available, otherwise posts the status change itself.
   *
   * The API rejects the request when the action could not be carried out — for
   * example a contract-sign email that was not sent because the order has no
   * OpenSign signing link. That reason is surfaced to the agent rather than
   * discarded, since the endpoint previously reported success regardless.
   *
   * @returns {void}
   */
  const handleUpdateStatus = () => {
    const { id, status, row } = statusDialog;
    if (TasksUIProps.openUpdateTasksStatusDialog) {
      // provider is responsible for performing update and refreshing list
      TasksUIProps.openUpdateTasksStatusDialog(row, status);
      setStatusDialog({ open: false, id: null, status: "", row: null });
      return;
    }

    // Send delete request to server with selected customer ids
    updateKycStatus({ user_id: row.order.user_id, status: status, o_id: row.order_id })
      .then((res) => {
        // Update snackbar with success message
        // Refresh customer list with current query params
        dispatch(fetchQTasks(TasksUIProps.queryParams));
        // Close delete dialog
        setStatusDialog({ open: false, id: null, status: "", row: null });
      })
      .catch((error) => {
        setSnack((previous) => ({
          call: true,
          type: "error",
          message:
            error?.response?.data?.message ??
            error?.message ??
            "The KYC status could not be updated.",
          id: previous.id + 1,
        }));
      });

    setStatusDialog({ open: false, id: null, status: "", row: null });
    // refresh list
    dispatch(fetchQTasks(TasksUIProps.queryParams));
  };

  return (
    <>
      {snack.call && (
        <SnackBarTool key={snack.id} type={snack.type} message={snack.message} />
      )}
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={loading}
              paginationProps={paginationProps}
              entities={entities}
            >
              {show && (
                <BootstrapTable
                  wrapperClasses="table-responsive"
                  bordered={false}
                  rowEvents={rowEvents}               // keep row click navigation
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  remote
                  hover
                  keyField="__tableId"                 // use stable key
                  data={
                    !permission?.task?.view || tableData === null
                      ? []
                      : tableData
                  }
                  onTableChange={getHandlerTableChange(
                    TasksUIProps.setQueryParams
                  )}
                  columns={columns}
                  {...paginationTableProps}
                ></BootstrapTable>
              )}
              {permission?.task?.view ? (
                <>
                  {(entities && entities?.length) || loading ? (
                    ""
                  ) : (
                    <NoRecord />
                  )}
                </>
              ) : (
                <NotAuthorized />
              )}
            </Pagination>
          );
        }}
      </PaginationProvider>

      <Modal
        show={statusDialog.open}
        onHide={() =>
          setStatusDialog({ open: false, id: null, status: "", row: null })
        }
        size="sm"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Status</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Select action</Form.Label>
            {console.log("statusDialog", statusDialog)}
            <Form.Control
              as="select"
              value={statusDialog.status}
              onChange={(e) =>
                setStatusDialog((s) => ({ ...s, status: e.target.value }))
              }
            >
              <option value="">Select</option>

              {(statusDialog?.row?.order?.is_cancel) ? null : (
                <>
              {statusDialog?.row?.kyc_status === "pending_kyc" && (
                <option value="pending_manual_kyc">
                  Move to Pending Manual ID Check
                </option>
              )}

              {/* Visible only if current status is Pending Manual ID Check */}
              {statusDialog?.row?.kyc_status === "pending_manual_kyc" && (
                <option value="pending_contract_sign">
                  Mark manual Id verification complete
                </option>
              )}

              {(statusDialog?.row?.kyc_status === "pending_kyc" ||
                statusDialog?.row?.kyc_status === "not_started") && (
                <option value="send_pending_kyc">Email for different ID verification</option>
              )}

              {/* Visible only if cpending_contract_sign*/}
              {statusDialog?.row?.kyc_status === "pending_contract_sign" && (
                <>
                <option value="pending_manual_contract_sign">Manual contract sign</option>
                <option value="send_pending_contract_sign">Email For contract sign</option>
                </>
              )}

               {statusDialog?.row?.kyc_status === "pending_manual_contract_sign" && (
                <>
                <option value="pending_access">Manual contract sign complete</option>
                </>
              )}

               {statusDialog?.row?.kyc_status === "pending_access" && (
                <>
                <option value="complete">Manual access complete</option>
                </>
              )}
              </>
              )}
            </Form.Control>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() =>
              setStatusDialog({ open: false, id: null, status: "", row: null })
            }
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={!statusDialog.status}
            onClick={() => handleUpdateStatus(statusDialog.row, statusDialog.status)}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <ContactDealTaskModal dialog={dialog} setDialog={setDialog} />
    </>
  );
};

export default KycTable;
